import type { ItemType } from "@/types/item";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { useTranslation } from "react-i18next";

const fetchItems = async (query: string, lang: string): Promise<ItemType[]> => {
  const response = await axios.get(
    `https://kaman.rest/api/items?search=${query}`
  );

  const items = response.data.data.items.filter(
    (item: any) => item.company && item.category
  );

  return items.map((item: any) => ({
    id: item.id,
    name: item.name,
    description: item.description,
    price: item.price,
    image: item.image,
    companyName: item.company.name,
    companyId: item.company.id,
    categoryName: item.category.name,
  }));
};

export const useItems = (query: string) => {
  const { i18n } = useTranslation();

  return useQuery<ItemType[]>({
    queryKey: ["items", query],
    queryFn: () => fetchItems(query, i18n.language),
    enabled: query.length >= 2,
  });
};
